import { render, staticRenderFns } from "./Epics.vue?vue&type=template&id=028c2dce&scoped=true&"
import script from "./Epics.vue?vue&type=script&lang=ts&"
export * from "./Epics.vue?vue&type=script&lang=ts&"
import style0 from "./Epics.vue?vue&type=style&index=0&id=028c2dce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028c2dce",
  null
  
)

export default component.exports